import { Avatar, Card, Chip } from '@mui/material';
import { alpha, lighten, styled } from '@mui/material/styles';

const activeProp = { shouldForwardProp: (prop: PropertyKey) => prop !== 'active' };

/** Card that reads as live (green wash, glow) or dormant (grey wash); `active` flips the whole palette, hover included. */
export const ActiveStateCard = styled(Card, activeProp)<{ active?: boolean }>(
  ({ theme, active = false }) => ({
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    background: active
      ? `linear-gradient(135deg, ${theme.palette.success.lighter} 0%, ${theme.palette.info.lighter} 100%)`
      : `linear-gradient(135deg, ${theme.palette.grey[100]} 0%, ${theme.palette.grey[200]} 100%)`,
    border: '1px solid',
    borderColor: active ? theme.palette.success.light : theme.palette.grey[200],
    boxShadow: active
      ? `0 4px 20px ${alpha(theme.palette.success.light, 0.15)}`
      : `0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
    '&:hover': {
      boxShadow: active
        ? `0 8px 25px ${alpha(theme.palette.success.light, 0.25)}`
        : `0 6px 20px ${alpha(theme.palette.common.black, 0.15)}`,
      borderColor: active ? theme.palette.success.main : theme.palette.primary.light,
    },
  }),
);

export const ActiveStateAvatar = styled(Avatar, activeProp)<{ active?: boolean }>(
  ({ theme, active = false }) => ({
    width: 28,
    height: 28,
    background: active
      ? `linear-gradient(135deg, ${theme.palette.success.light}, ${lighten(theme.palette.success.light, 0.15)})`
      : `linear-gradient(135deg, ${theme.palette.grey[500]}, ${theme.palette.grey[600]})`,
  }),
);

export const ActiveStateChip = styled(Chip, activeProp)<{ active?: boolean }>(
  ({ theme, active = false }) => ({
    height: 20,
    fontSize: '0.6rem',
    borderColor: active ? theme.palette.success.light : theme.palette.grey[300],
    color: active ? theme.palette.success.dark : theme.palette.text.secondary,
    '& .MuiChip-icon': {
      color: active ? theme.palette.success.main : theme.palette.action.active,
      fontSize: '0.7rem',
    },
  }),
);
